import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MondrianPanel } from './ui/MondrianPanel';
import { MondrianGrid } from './MondrianGrid';
interface EvolutionStagesProps {
  currentStage: 0 | 1 | 2 | 3 | 4; // 0=Empty, 1=Real, 2=Expression, 3=Cubist, 4=Neo-Plastic
  originalImage: string | null;
}
export function EvolutionStages({
  currentStage,
  originalImage
}: EvolutionStagesProps) {
  if (!originalImage) return null;
  const stages = [{
    id: 1,
    title: '写实 (Realism)',
    desc: '具象世界'
  }, {
    id: 2,
    title: '表现 (Expressionism)',
    desc: '色彩增强'
  }, {
    id: 3,
    title: '解构 (Cubism)',
    desc: '破碎重组'
  }, {
    id: 4,
    title: '本质 (Neo-Plasticism)',
    desc: '纯粹抽象'
  }];
  return <div className="w-full grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-176">
      {stages.map(stage => {
      const isActive = currentStage >= stage.id;
      const isCurrent = currentStage === stage.id;
      return <div key={stage.id} className="flex flex-col gap-2" data-id="element-177">
            <MondrianPanel noPadding className={`
                aspect-square relative overflow-hidden transition-all duration-500
                ${isCurrent ? 'ring-4 ring-mondrian-yellow ring-offset-4' : ''}
                ${!isActive ? 'opacity-30 grayscale' : 'opacity-100'}
              `} data-id="element-178">
              <AnimatePresence mode="wait" data-id="element-179">
                {stage.id === 1 && <motion.img src={originalImage} alt="Original" className="w-full h-full object-cover" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} data-id="element-180" />}

                {stage.id === 2 && isActive && <motion.div initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} className="w-full h-full relative" data-id="element-181">
                    <img src={originalImage} className="w-full h-full object-cover blur-sm contrast-150 saturate-200" alt="Expressionism" data-id="element-182" />
                    <div className="absolute inset-0 bg-mondrian-red/20 mix-blend-overlay" data-id="element-183" />
                  </motion.div>}

                {stage.id === 3 && isActive && <motion.div initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} className="w-full h-full relative overflow-hidden bg-gray-200" data-id="element-184">
                    {/* Simulated Cubism effect with CSS clip-paths or multiple image layers */}
                    <div className="absolute inset-0 grid grid-cols-3 grid-rows-3 gap-1 rotate-3 scale-110" data-id="element-185">
                      {[...Array(9)].map((_, i) => <div key={i} className="overflow-hidden relative bg-white" data-id="element-186">
                          <img src={originalImage} className="absolute w-[300%] h-[300%] max-w-none object-cover opacity-80" style={{
                    left: `-${i % 3 * 100}%`,
                    top: `-${Math.floor(i / 3) * 100}%`,
                    transform: `rotate(${Math.random() * 20 - 10}deg)`
                  }} data-id="element-187" />
                        </div>)}
                    </div>
                  </motion.div>}

                {stage.id === 4 && isActive && <MondrianGrid density="high" animated data-id="element-188" />}
              </AnimatePresence>
            </MondrianPanel>

            <div className="text-center" data-id="element-189">
              <div className="font-bold text-sm md:text-base" data-id="element-190">
                {stage.title}
              </div>
              <div className="text-xs text-gray-500" data-id="element-191">{stage.desc}</div>
            </div>
          </div>;
    })}
    </div>;
}